<template>
  <div class="listBox">
    <div class="title">项目展示</div>
    <div class="content">
      <router-link
          class="item"
          v-for="item in titleList"
          :to="{
            name: 'Detail',
            query: {
              id: item.id
            }
          }"
          :key="item.id"
      >{{item.title}}</router-link>
    </div>
  </div>
</template>

<script>
import titleList from "@/static/home/titleList";
export default {
  name: "Home",
  data(){
    return {
      titleList
    }
  },
  created(){
    console.log("%cHome","background: #FF6EC7;")
  }
}
</script>

<style scoped>
  .listBox{
    background: #f4f6f8;
    width: 800px;
    height: 70vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    box-shadow: 7px 7px 12px rgba(0,0,0,.4);
    border-radius: 10px;
  }
  .listBox .title{
    width: 100%;
    text-align: center;
    font-size: 1.7rem;
    font-weight: bold;
    line-height: 2;
    border-radius: inherit;
    margin-bottom: 20px;
  }
  .listBox .content{
    width: 90%;
    height: calc(70vh - 90px);
    margin: 0 auto;
    background: #ffffff;
    border-radius: inherit;
    overflow: auto;
  }
  /*滚轮条样式*/
  .listBox .content::-webkit-scrollbar {
    width: 5px;
    border-radius: 3px;
  }
  .listBox .content::-webkit-scrollbar-thumb {
    background-image: linear-gradient(to top, #9795f0 0%, #fbc8d4 100%);
    border-radius: 3px;
  }
  /*end*/
  .listBox .content .item{
    display: inline-block;
    width: 45%;
    margin: 5px 2.5%;
    color: #000000;
    text-decoration: none;
    padding-left: 20px;
    line-height: 2.5;
    border-radius: inherit;
    background: #f1f1ed;
  }
  .listBox .content .item:hover{
    background-image: linear-gradient(-20deg, #e9defa 0%, #fbfcdb 100%);
  }
</style>